import { Box, RadioButtonGroup, Text, DateInput } from 'grommet';
import { LeaseAgreementType } from '../../../../customer-profile/types/Field';
import { formatDateWithoutTZ, formatISODateWithoutTZ } from '../../../../customer-profile/utils/utils';
import { useState } from 'react';
import { Calendar } from 'grommet-icons/icons';
import React from 'react';
import { t } from 'i18next';
import { FormInputProps } from '../FieldItem';

const baseStyle = { fontSize: '16px', fontWeight: 400 };
const sharedStyle = { ...baseStyle, color: '#282828', lineHeight: '24px', textAlign: 'left' as const };

export const FieldSituationInput: React.FC<FormInputProps> = ({ field, saveField, options }) => {
  return (
    <>
      <Box gap={'4px'}>
        <Text style={{ ...sharedStyle, textAlign: 'start' }}>{t('fieldFlow.fieldItem.ownership.title')}</Text>

        <RadioButtonGroup
          direction={'row'}
          name={'situation'}
          data-cy={`field-situation-${field.properties?.['name']}`}
          value={field.properties?.['situation']}
          onChange={({ target }) => saveField({ ...field, properties: { ...field.properties, situation: target.value } })}
          options={options}
        />
        {field.properties?.['situation'] === 'LEASED' && <LeasedFieldDateInput field={field} saveField={saveField} />}
      </Box>
    </>
  );
};

const LeasedFieldDateInput = ({ field, saveField }: any) => (
  <Box gap='16px' direction='column' margin={{ top: '12px' }}>
    <Box gap='16px' direction='row'>
      <LeaseDateInput field={field} type='start' saveField={saveField} />
      <LeaseDateInput field={field} type='end' saveField={saveField} />
    </Box>
    <LeaseAgreementRadio field={field} saveField={saveField} />
  </Box>
);

const LeaseDateInput = ({ field, type, saveField }: any) => {
  const key = `lease${type.charAt(0).toUpperCase()}${type.slice(1)}Date`;
  const [date, setDate] = useState(formatDateWithoutTZ(field.properties?.[key]));

  const handleChange = (input: string | undefined) => {
    setDate(input || '');
    const value: string | null = formatISODateWithoutTZ(input);
    saveField({ ...field, properties: { ...field.properties, [key]: value } });
  };

  return (
    <Box width='48%' direction='column'>
      <Text style={{ ...sharedStyle, lineHeight: '20px', whiteSpace: 'nowrap', marginBottom: '0.25rem' }}>
        {t(`fieldFlow.fieldItem.ownership.lease.${type}Date`)}
      </Text>
      <Box style={{ background: '#fff', border: '1px solid #282828', minHeight: '29px' }}>
        <DateInput
          size='small'
          format='mm/dd/yyyy'
          style={{ ...baseStyle, letterSpacing: '0.07em', padding: '4px 8px' }}
          icon={<Calendar size='16px' style={{ marginLeft: '8px', color: '#282828' }} />}
          value={date}
          onChange={({ value }) => handleChange(Array.isArray(value) ? value[0] : value)}
          data-cy={`field-lease-${type}-date-${field.properties?.['name']}`}
        />
      </Box>
    </Box>
  );
};

const LeaseAgreementRadio = ({ field, saveField }: any) => {
  const [agreementType, setAgreementType] = useState(field.properties?.['leaseAgreementType']);
  const agreementTypes = ['written', 'verbal'];

  const options = agreementTypes.map((type) => ({
    label: <Text style={{ fontSize: '14px', fontWeight: 400 }}>{t(`fieldFlow.fieldItem.ownership.lease.${type}Agreement`)}</Text>,
    'data-cy': `${type}-lease-agreement-radio-btn=${field.properties?.['name']}`,
    value: type.toUpperCase(),
  }));

  const handleChange = (type: LeaseAgreementType) => {
    setAgreementType(type);
    saveField({ ...field, properties: { ...field.properties, leaseAgreementType: type } });
  };

  return (
    <Box gap='4px'>
      <Text style={sharedStyle}>{t('fieldFlow.fieldItem.ownership.lease.agreementTitle')}</Text>
      <RadioButtonGroup
        direction='row'
        name='agreementType'
        data-cy={`field-practiceType-${field.properties?.['name']}`}
        value={agreementType}
        onChange={({ target }) => handleChange(target.value as LeaseAgreementType)}
        options={options}
      />
    </Box>
  );
};
